window.Visualizations.Highcharts.SimpleColumn = Object.assign({}, window.Visualizations.Highcharts.Base, {
  render: function (opts) {
    this.renderChart(opts.highchart_html_id, opts, {
      chart: {
        type: 'column'
      },
      xAxis: {
        categories: opts.categories
      },
      yAxis: {
        min: 0,
        title: {
          text: opts.y_title
        }
      },
      legend: {
        enabled: false
      },
      series: opts.series
    });
  }
});
